
import { useState } from 'react';
import { KpiCardType } from '../types';
import { reorderCards } from '../utils';
import { useToast } from '@/hooks/use-toast';

export const useDragAndDrop = (
  kpiCards: KpiCardType[], 
  setKpiCards: React.Dispatch<React.SetStateAction<KpiCardType[]>>
) => {
  const [draggedCardId, setDraggedCardId] = useState<string | null>(null);
  const [dragOverCardId, setDragOverCardId] = useState<string | null>(null);
  const { toast } = useToast();

  const dragStart = (id: string) => {
    console.log('Starting drag operation with card ID:', id);
    setDraggedCardId(id);
  };

  const dragOver = (id: string) => {
    if (id !== draggedCardId) {
      setDragOverCardId(id);
    }
  };

  const drop = () => {
    try {
      if (draggedCardId && dragOverCardId && draggedCardId !== dragOverCardId) {
        console.log('Completing drag and drop operation:');
        console.log('- Dragged card ID:', draggedCardId);
        console.log('- Target card ID:', dragOverCardId);
        
        // Find the card titles for better toast messages
        const draggedCard = kpiCards.find(card => card.id === draggedCardId);
        const targetCard = kpiCards.find(card => card.id === dragOverCardId);
        
        // Apply simple swap between the two cards only
        const updatedCards = reorderCards([...kpiCards], draggedCardId, dragOverCardId);
        setKpiCards(updatedCards);
        
        toast({
          title: "Cards Swapped",
          description: draggedCard && targetCard 
            ? `"${draggedCard.title}" has been swapped with "${targetCard.title}"`
            : "The positions of the selected cards have been swapped",
        });
      } else if (draggedCardId) {
        console.log('Drop cancelled - no valid target or same card');
      }
    } catch (error) {
      console.error('Error during drag and drop operation:', error);
      toast({
        title: "Error Swapping Cards",
        description: "There was a problem updating the card positions.",
        variant: "destructive"
      });
    } finally {
      // Reset drag state
      setDraggedCardId(null);
      setDragOverCardId(null);
    }
  };

  return {
    draggedCardId,
    dragOverCardId,
    dragStart,
    dragOver,
    drop,
  };
};
